export default __webpack_public_path__ + "static/media/logout-icon.dab8a6b4.svg";